/**
 * explanation-request.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Richard A Arriaga <rarriaga@safetyweb.org>
 */

import { Message } from "../../general/message";
import { ReplyVerifyingMessage } from "../../general/reply-message";
import { MessageTag } from "../../message-tag";

/**
 * A client transmits a {@link ExplanationReques} when it wishes to obtain an
 * explanation graph for a given {@link AlgorithmStep}.
 */
export class ExplanationRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_EXPLANATION;
	public static tag : MessageTag = MessageTag.REQ_EXPLANATION;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_EXPLANATION);
  }

  /**
   * Construct a new {@link ExplanationRequest}.
   *
   * @param stepId
   *        The server id of the {@link AlgorithmStep} to explain.
   * @param extendedGraph
   *        {@code true} if computation steps are to be included
   *        {@code false} if the computation steps should be
   *        folded out directly connecting transitively linked
   *        algorithm steps.
   */
  constructor (public stepId : number, public extendedGraph : boolean = false)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/algorithms/graphs/explanation-request.ts